import { render, staticRenderFns } from "./ManageThanks.vue?vue&type=template&id=4e06c8da&scoped=true&"
import script from "./ManageThanks.vue?vue&type=script&lang=js&"
export * from "./ManageThanks.vue?vue&type=script&lang=js&"
import style0 from "./ManageThanks.vue?vue&type=style&index=0&id=4e06c8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06c8da",
  null
  
)

export default component.exports